import { type RouteRecordRaw } from 'vue-router'

export const customerRoutes: RouteRecordRaw[] = [
  {
    path: '/customers',
    component: () => import('layouts/receiver/MainLayout.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'manage-customers',
        component: () => import('pages/receiver/customers/ManageCustomers.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'import',
        name: 'import-customers',
        component: () => import('pages/receiver/customers/CustomerImport.vue'),
        meta: {
          requiresAuth: true,
          fluid: 'container-xxl',
        },
      },
      {
        path: 'import/:importId',
        name: 'import-customers-report',
        component: () =>
          import('pages/receiver/customers/CustomerImportReport.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'files/:customerId',
        name: 'customer-files',
        component: () => import('pages/receiver/customers/CustomerFiles.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
]
